import { Tabs, withStyles } from "@material-ui/core";

import { blue } from "../../styles/variables";

const CustomTabs = withStyles({
  indicator: {
    backgroundColor: `${blue}`,
  },
})(Tabs);

export default CustomTabs;
